import { defineMessages } from 'react-intl';

export default defineMessages({
  navAriaLabel: {
    id: 'shared.breadcrumbs.navAriaLabel',
    description: 'aria-label for breadcrumb navigation',
    defaultMessage: 'Breadcrumbs',
  },
});
